import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $, nothing as w } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import '../buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import { normalizeUnicodeText } from '../../../common/navigation-titles.js';
import img from '../../../../assets/images/chevron-right.svg.js';
import css_248z from './nav-item.scss.js';

class NavItem extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.linkHref = '';
        this.ariaLabel = '';
        this.isNoFollow = false;
        this.target = '';
    }
    get normalizedTitle() {
        return normalizeUnicodeText(this.title);
    }
    renderAction() {
        if (this.linkHref && this.linkHref !== '#') {
            return $ `<a class="nav-link" href="${this.linkHref}" tabindex="0" title="${this.normalizedTitle}" aria-label="${this.ariaLabel || w}" target="${this.target || w}" rel="${this.isNoFollow ? 'nofollow' : 'follow'}"><span class="link-text">${this.normalizedTitle}</span> <img src="${img}" aria-hidden="true" alt="" class="arrow-icon"></a>`;
        }
        return $ `<span class="nav-link" title="${this.normalizedTitle}" aria-label="${this.ariaLabel || w}"><span class="link-text">${this.normalizedTitle}</span></span>`;
    }
    render() {
        return $ `<div class="${o({
            'nav-container': true,
            rtl: this.rtl || isRTL(),
            emptyTitle: !this.title,
        })}">${this.title ? this.renderAction() : w}</div>`;
    }
}
NavItem.styles = css_248z;
NavItem.shadowRootOptions = Object.assign(Object.assign({}, s.shadowRootOptions), { delegatesFocus: true });
__decorate([
    e({ type: String })
], NavItem.prototype, "title", void 0);
__decorate([
    e({ type: Boolean })
], NavItem.prototype, "rtl", void 0);
__decorate([
    e()
], NavItem.prototype, "linkHref", void 0);
__decorate([
    e()
], NavItem.prototype, "ariaLabel", void 0);
__decorate([
    e()
], NavItem.prototype, "linkIcon", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], NavItem.prototype, "isNoFollow", void 0);
__decorate([
    e({ type: String, reflect: true })
], NavItem.prototype, "target", void 0);
customElements.define('nav-item', NavItem);

export { NavItem };
